var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.733,
    height: 27.95,
    viewBox: "0 0 26.733 27.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-search-6889712",
    transform: "translate(-4.506 -3.507)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M6.451,9.231a.419.419,0,0,1-.6.1.464.464,0,0,1-.1-.628L5.8,8.638a.419.419,0,0,1,.6-.1.464.464,0,0,1,.1.628ZM24.208,24.514l5.9,6.173a.465.465,0,0,1,0,.638.418.418,0,0,1-.61,0l-5.9-6.173a11.581,11.581,0,0,1-16.592-.312,12.663,12.663,0,0,1-3.37-6.993,13.014,13.014,0,0,1,1.28-7.736A.421.421,0,0,1,5.5,9.925a.46.46,0,0,1,.177.607,12.094,12.094,0,0,0-1.186,7.183A11.744,11.744,0,0,0,7.616,24.2a10.752,10.752,0,0,0,15.683,0,11.972,11.972,0,0,0,0-16.4A10.736,10.736,0,0,0,8.662,6.837a.42.42,0,0,1-.605-.079.466.466,0,0,1,.075-.633,11.576,11.576,0,0,1,15.776,1.04,12.909,12.909,0,0,1,.3,17.348ZM15.457,7.922a.451.451,0,0,1,0-.9,8.374,8.374,0,0,1,6.072,2.631l0,0A9.162,9.162,0,0,1,24.047,16a.432.432,0,1,1-.862,0,8.244,8.244,0,0,0-2.262-5.713,7.537,7.537,0,0,0-5.465-2.367ZM7.535,7.886a.418.418,0,0,1-.609.006.465.465,0,0,1-.006-.636L6.975,7.2a.418.418,0,0,1,.609-.006.465.465,0,0,1,.006.636Z",
    transform: "translate(1 0)",
    fill: "#1c1919"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.dbc810f7f090bb6204e886fb8d8d5719.svg";
export { ForwardRef as ReactComponent };